import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Trash2, ListOrdered } from "lucide-react";
import { formatCurrency } from "../../lib/utils";
import { METHOD_LABELS, TYPE_LABELS } from "../../lib/cashPrint";

const TYPE_CLS = {
  sale: "bg-sky-500/15 text-sky-600",
  entry: "bg-emerald-500/15 text-emerald-600",
  exit: "bg-red-500/15 text-red-600",
  opening: "bg-zinc-500/15 text-zinc-600",
  closing: "bg-zinc-500/15 text-zinc-600",
};

export const CashMovementsTable = ({ movements, canDelete, onDelete }) => (
  <Card data-testid="cash-movements-card">
    <CardHeader className="pb-2">
      <CardTitle className="text-base flex items-center gap-2"><ListOrdered className="w-4 h-4" /> Movimentos da sessão <span className="text-muted-foreground text-sm font-normal">({movements.length})</span></CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-muted-foreground border-b">
              <th className="px-4 py-2 font-medium">Hora</th>
              <th className="px-2 py-2 font-medium">Tipo</th>
              <th className="px-2 py-2 font-medium">Descrição</th>
              <th className="px-2 py-2 font-medium">Categoria</th>
              <th className="px-2 py-2 font-medium">Método</th>
              <th className="px-2 py-2 font-medium">Operador</th>
              <th className="px-2 py-2 font-medium text-right">Valor</th>
              <th className="px-2 py-2 w-10" />
            </tr>
          </thead>
          <tbody>
            {movements.map((m) => (
              <tr key={m.movement_id} className={`border-b last:border-0 hover:bg-muted/40 ${m.cancelled ? "opacity-60" : ""}`} data-testid={`cash-movement-${m.movement_id}`}>
                <td className="px-4 py-2 font-mono text-xs whitespace-nowrap">{new Date(m.created_at).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })}</td>
                <td className="px-2 py-2"><Badge className={`${TYPE_CLS[m.type] || ""} font-semibold`} data-testid={`cash-movement-type-${m.movement_id}`}>{TYPE_LABELS[m.type] || m.type}</Badge>{m.cancelled && <Badge className="ml-1 bg-red-500/15 text-red-600 font-semibold" data-testid={`cash-movement-cancelled-${m.movement_id}`}>Anulada</Badge>}</td>
                <td className="px-2 py-2 max-w-[320px] truncate" title={m.description}>{m.description}{m.reference_type === "manual" ? "" : <span className="ml-1 text-[10px] text-muted-foreground uppercase">auto</span>}</td>
                <td className="px-2 py-2 text-muted-foreground">{m.category}</td>
                <td className="px-2 py-2 text-muted-foreground whitespace-nowrap">{METHOD_LABELS[m.payment_method] || m.payment_method}{m.payment_method === "card" && <span className="block text-[10px]">{m.tpa_name || "sem TPA"}</span>}</td>
                <td className="px-2 py-2 text-muted-foreground truncate max-w-[140px]">{m.created_by_name}</td>
                <td className={`px-2 py-2 text-right font-mono font-semibold whitespace-nowrap ${m.cancelled ? "line-through text-muted-foreground" : m.type === "exit" ? "text-red-600" : m.type === "entry" ? "text-emerald-600" : ""}`}>
                  {m.type === "exit" ? "-" : m.type === "sale" || m.type === "entry" ? "+" : ""}{formatCurrency(m.amount)}
                </td>
                <td className="px-2 py-2 text-right">
                  {canDelete && m.reference_type === "manual" && (
                    <Button size="icon" variant="ghost" className="h-7 w-7 text-destructive" onClick={() => onDelete(m)} title="Anular movimento" data-testid={`cash-movement-delete-${m.movement_id}`}><Trash2 className="w-3.5 h-3.5" /></Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {movements.length === 0 && <p className="text-center text-sm text-muted-foreground py-8" data-testid="cash-movements-empty">Ainda sem movimentos nesta sessão — as vendas do POS aparecem aqui automaticamente.</p>}
      </div>
    </CardContent>
  </Card>
);
